import React from "react";
import { Card, CardContent, Stack, Typography, Button } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Link as RouterLink } from "react-router-dom";

export default function UpgradeNotice({
    title = "Buchhaltungsfunktionen freischalten",
    description = "Diese Funktion ist im 20 € netto Buchhaltungstarif enthalten.",
    actionLabel = "Zum Upgrade",
    to = "/registration",
    size = "regular",
    fullHeight = false,
    sx,
    children,
    ...cardProps
}) {
    const isCompact = size === "compact";

    return (
        <Card
            variant="outlined"
            {...cardProps}
            sx={{
                borderRadius: 3,
                borderStyle: "dashed",
                borderColor: "warning.light",
                backgroundColor: "rgba(255,165,0,0.04)",
                height: fullHeight ? "100%" : "auto",
                display: "flex",
                flexDirection: "column",
                ...(sx || {}),
            }}
        >
            <CardContent sx={{ display: "flex", flexDirection: "column", gap: isCompact ? 1 : 1.5, flexGrow: 1 }}>
                <Stack
                    direction="row"
                    spacing={1.5}
                    alignItems={isCompact ? "center" : "flex-start"}
                    sx={{ flexGrow: 1 }}
                >
                    <LockOutlinedIcon sx={{ color: "warning.main", mt: isCompact ? 0 : 0.5 }} />
                    <Stack spacing={isCompact ? 0.5 : 1} flexGrow={1}>
                        <Typography variant={isCompact ? "subtitle1" : "h6"} fontWeight={700}>
                            {title}
                        </Typography>
                        {(!isCompact && description) && (
                            <Typography variant="body2" color="text.secondary">
                                {description}
                            </Typography>
                        )}
                        {children}
                    </Stack>
                </Stack>
                <Button
                    component={RouterLink}
                    to={to}
                    variant="contained"
                    size={isCompact ? "small" : "medium"}
                    endIcon={isCompact ? null : <ArrowForwardIcon />}
                    sx={{
                        alignSelf: "flex-start",
                        borderRadius: 2,
                        bgcolor: "orange",
                        color: "#000",
                        "&:hover": { bgcolor: "#cc7a00" },
                    }}
                >
                    {actionLabel}
                </Button>
            </CardContent>
        </Card>
    );
}
